import { useSitecoreContext as useJssSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

export const useSitecoreContext = () => {
  const { sitecoreContext } = useJssSitecoreContext();
  return sitecoreContext;
};
